import type { Board } from "../board";
import { isRobotActor, PRIORITY_DEFAULT, RobotActorState, type OnPlayerArrive } from "../interfaces";
import { Thing } from "../thing";

export class PowerPlantLightsOnArrival extends Thing implements OnPlayerArrive {
	static key = "PowerPlantLightsOnArrival";

	onPlayerArrive(board: Board): void {
		if (!board.gameFlags.activatedPowerPlant) return;
		board.darkness = 0;
		for (const thing of board.getPhysicalThings()) {
			if (isRobotActor(thing)) {
				thing.setState(RobotActorState.WANDERING);
			}
		}
	}

	getArrivePriority(): number {
		return PRIORITY_DEFAULT;
	}

	static deserialize(_data: any): PowerPlantLightsOnArrival {
		return new PowerPlantLightsOnArrival();
	}
}
